import React, { useEffect, useState } from 'react';
import api from '../../utils/api';

function SubscriptionStatus() {
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    api.get('/subscriptions')
      .then(res => setSubscription(res.data.subscription || null))
      .catch(() => setError('Failed to load subscription'))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div>Loading subscription...</div>;
  if (error) return <div className="alert alert-danger">{error}</div>;
  if (!subscription) return <div>No active subscription.</div>;

  return (
    <div className="card my-3">
      <div className="card-body">
        <h5 className="card-title">Current Plan: {subscription.plan_name}</h5>
        <div>Status: {subscription.payment_status}</div>
        <div>Valid Until: {subscription.end_date ? new Date(subscription.end_date).toLocaleString() : '-'}</div>
        {subscription.is_trial_active ? <div className="badge bg-info mt-2">Free Trial Active</div> : null}
      </div>
    </div>
  );
}

export default SubscriptionStatus;
